import { Befehl } from '../models'
import { findAuftrag, hasFieldContent } from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

export function hasBefehl25EmptyFields(befehl: Befehl): boolean {
  if (!befehl.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag2510 = findAuftrag(befehl, '25.10')
  if (auftrag2510) {
    const has2512_abzw = hasFieldContent(auftrag2510, '25.12', 'abzw')
    const has2513_uest = hasFieldContent(auftrag2510, '25.13', 'uest')

    if (!has2512_abzw && !has2513_uest) {
      return true
    }
  }

  const auftrag2520 = findAuftrag(befehl, '25.20')
  if (auftrag2520) {
    const has2522_abzw = hasFieldContent(auftrag2520, '25.22', 'abzw')
    const has2523_uest = hasFieldContent(auftrag2520, '25.23', 'uest')

    if (!has2522_abzw && !has2523_uest) {
      return true
    }
  }

  const auftrag2530 = findAuftrag(befehl, '25.30')
  if (auftrag2530) {
    const has2532_abzw = hasFieldContent(auftrag2530, '25.32', 'bf')
    const has2533_uest = hasFieldContent(auftrag2530, '25.33', 'bft')

    if (!has2532_abzw && !has2533_uest) {
      return true
    }
  }

  return false
}
